document.addEventListener("DOMContentLoaded", function () {
  const heroImageryBlocks = document.querySelectorAll(
    ".hero-imagery-blocks__block"
  );
  if (!heroImageryBlocks) return;

  const windowWidth = window.innerWidth;

  function throttle(func, limit) {
    let lastFunc;
    let lastRan;

    return function (...args) {
      const context = this;
      const now = Date.now();

      if (!lastRan) {
        func.apply(context, args);
        lastRan = now;
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (now - lastRan >= limit) {
            func.apply(context, args);
            lastRan = now;
          }
        }, limit - (now - lastRan));
      }
    };
  }

  function handleScroll(element) {
    const threshold = 0.05; // Adjust threshold as needed

    const viewportHeight = window.innerHeight;
    const elementRect = element.getBoundingClientRect();
    const distanceFromTop = elementRect.top;
    const distanceFromBottom = viewportHeight - elementRect.bottom;

    // Check if the element is within the threshold of the viewport
    if (
      distanceFromTop <= viewportHeight * (1 - threshold) && // Top of the element is within the viewport
      distanceFromBottom >= viewportHeight * threshold // Bottom of the element is within the viewport
    ) {
      element.setAttribute("data-show", "true");
    } else {
      // Element is completely out of the viewport
      element.setAttribute("data-show", "false");
    }
  }

  if (windowWidth > 768) {
    heroImageryBlocks.forEach(function (block) {
      block.addEventListener("mouseover", function (e) {
        e.currentTarget.setAttribute("data-show", "true");
      });
      block.addEventListener("mouseout", function (e) {
        e.currentTarget.setAttribute("data-show", "false");
      });
    });
  } else {
    // Throttle the scroll event for better performance
    const throttledScroll = throttle(() => {
      heroImageryBlocks.forEach(function (block, index) {
        handleScroll(block);
      });
    }, 100); // Adjust the throttle limit (in milliseconds) as needed

    window.addEventListener("scroll", throttledScroll);

    return () => {
      window.removeEventListener("scroll", throttledScroll);
    };
  }
});
